export default "__VITE_ASSET__DlvH0yEO__"